import { FONT_FAMILY } from '../constants';

export type FontWeight =
  | 'bold'
  | 'semiBold'
  | 'semiBoldItalic'
  | 'boldItalic'
  | 'extraBold'
  | 'extraBoldItalic'
  | 'italic'
  | 'light'
  | 'lightItalic'
  | 'medium'
  | 'mediumItalic'
  | 'regular';

export type FontSize = 'XXL' | 'XL' | 'LG' | 'MD' | 'SM' | 'XS' | 'XXS';

export type TextAlign = 'center' | 'left' | 'right';

export type Font = {
  fontFamily: string;
  fontSize: number;
  lineHeight: number;
  textAlign: TextAlign;
};

export const getFontFamily = (weight: FontWeight): string => {
  switch (weight) {
    case 'bold':
      return FONT_FAMILY.OpenSansBold;
    case 'semiBold':
      return FONT_FAMILY.OpenSansSemiBold;
    case 'semiBoldItalic':
      return FONT_FAMILY.OpenSansSemiBoldItalic;
    case 'boldItalic':
      return FONT_FAMILY.OpenSansBoldItalic;
    case 'extraBoldItalic':
      return FONT_FAMILY.OpenSansExtraBoldItalic;
    case 'italic':
      return FONT_FAMILY.OpenSansItalic;
    case 'light':
      return FONT_FAMILY.OpenSansLight;
    case 'lightItalic':
      return FONT_FAMILY.OpenSansLightItalic;
    case 'medium':
      return FONT_FAMILY.OpenSansMedium;
    case 'mediumItalic':
      return FONT_FAMILY.OpenSansMediumItalic;
    default:
      return FONT_FAMILY.OpenSansRegular;
  }
};

export const getFontSize = (size: FontSize): number => {
  switch (size) {
    case 'XXL':
      return 34;
    case 'XL':
      return 24;
    case 'LG':
      return 18;
    case 'MD':
      return 16;
    case 'SM':
      return 14;
    case 'XS':
      return 12;
    case 'XXS':
      return 9;
    default:
      return 16;
  }
};

export const getFont = (size?: FontSize | number, weight?: FontWeight, textAlign?: TextAlign): Font => {
  const fontSize = typeof size === 'number' ? size : getFontSize(size ?? 'MD');
  return {
    fontFamily: getFontFamily(weight ?? 'regular'),
    fontSize,
    lineHeight: fontSize * 1.4,
    textAlign: textAlign ?? 'left',
  };
};
